/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupByCohortKind = (typeof GroupByCohortKind)[keyof typeof GroupByCohortKind];

export const GroupByCohortKind = {
  cohort: 'cohort',
} as const;
